import styled from '@emotion/styled';

const StyledListItem = styled.li(
  {
    '&:first-of-type': {
      marginTop: '23px'
    },
    'marginTop': '16px'
  },
  ({ theme }) => ({
    a: {
      fontSize: theme.typography.fontSize.large,
      textDecoration: 'none',
      color: theme.palette.colors.lightPeriwinkle,
      fontWeight: theme.typography.fontWeightRegular
    }
  })
);

export default StyledListItem;
